import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Aggiunto stato di caricamento

    // Funzione per controllare se c'è già una sessione attiva al caricamento
    const checkLoginStatus = useCallback(async () => {
        try {
            // Usa withCredentials per inviare il cookie di sessione
            const { data } = await axios.get('/api/sessions/current', {
                withCredentials: true,
            });
            setUser(data);
        } catch (err) {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    // Esegue il check solo al primo caricamento
    useEffect(() => {
        checkLoginStatus();
    }, [checkLoginStatus]);

    // Funzione di Login
    const login = async (email, password) => {
        try {
            // Chiama l'API di login del tuo server
            const { data } = await axios.post('/api/sessions',
                { email, password },
                { withCredentials: true } // FONDAMENTALE per ricevere il cookie
            );
            setUser(data);
            return true; // Successo
        } catch (err) {
            console.error('Login fallito', err);
            setUser(null);
            return false; // Fallimento
        }
    };

    // Funzione di Logout
    const logout = async () => {
        try {
            await axios.delete('/api/sessions/current', {
                withCredentials: true,
            });
        } catch (err) {
            console.error('Logout fallito', err);
        } finally {
            setUser(null);
        }
    };

    const value = {
        user,
        loading, // Esponi lo stato di caricamento
        login,
        logout,
    };

    // Non renderizza l'app finché non abbiamo controllato lo stato del login
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};